<script>
import CrmBottomNavigation from "@/components/crm/CrmBottomNavigation.vue";

export default {
  name: "StandardV2Layout",
  components: {
    CrmBottomNavigation
  }
};
</script>

<template>
  <main class="standard-v2-layout">
    <div class="standard-v2-layout__content">
      <slot />
    </div>
    <CrmBottomNavigation />
  </main>
</template>

<style lang="scss" scoped>
.standard-v2-layout {
  // min-height: 100dvh;
  // background: #f7f7f7;
}

.standard-v2-layout__content {
  min-height: calc(100vh - 90px);
  padding: 14px 12px calc(90px + env(safe-area-inset-bottom));
  // min-height: 100dvh;
  // padding: 14px 12px calc(96px + env(safe-area-inset-bottom));
}
</style>
